import { ReactElement } from "react";

export type HeadlineProps = {
    isDeveloper:boolean;
}

export const Headline = (props:HeadlineProps) : ReactElement => {
    return <div>
        <div className="Headline">Sensative VSM Product Configuration Tool<br></br>{<div className="UserInfo">{props.isDeveloper ? "Developer Mode":"Online"}</div>}</div>
        <div className="IconTopLeft"><img src="logo192.png" style={{width:"40px", height:"40px"}}/></div>
    </div>;
}
